import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import {
  useDataModel,
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  params,
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Heading } from '@thd-olt-component-react/heading';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Image } from '@thd-olt-component-react/core-ui';
import { getURLFormat } from '../CollectionHelpers';
import './similar-collections.scss';

export const SimilarCollections = ({ collectionId, room }) => {

  const { channel } = useContext(ExperienceContext);
  const seeMoreStyleLink = room ? `/room/${getURLFormat(room)}` : '';
  const appId = (channel === 'mobile') ? 'mobileweb' : 'desktop';
  const {
    data
  } = useDataModel('collectionRecs', {
    variables: {
      collectionId,
      appId,
      maxCollections: '4',
      version: 'model1'
    }
  });
  const { collectionRecs } = data || {};
  const { similarCollections } = collectionRecs || {};

  if (!(similarCollections || []).length) {
    return null;
  }

  return (
    <div className="similar-collections">
      <div className="similar-collections__title">
        <Heading underline>
          Similar Rooms You May Like
        </Heading>
        {
          seeMoreStyleLink
          && (
            <a
              className="similar-collections__see-more"
              href={seeMoreStyleLink}
            >
              See More Styles
            </a>
          )
        }
      </div>
      <Row data-testid="similar-collection-grid">
        {
          (similarCollections || []).filter((sc) => sc?.media?.images?.[0]?.url).map((sc) => (
            <Col md={3} sm={6} key={`sc-${sc.collectionId}`} className="similar-collections__item">
              <a href={sc.url}>
                <Image
                  src={sc.media.images[0].url}
                  alt={sc.name}
                  width="1"
                  height="1"
                />
              </a>
              <div className="similar-collections__item--name">
                <a href={sc.url}>
                  <span>{sc.name}</span>
                </a>
              </div>
            </Col>
          ))
        }
      </Row>
    </div>
  );
};

SimilarCollections.displayName = 'SimilarCollections';

SimilarCollections.dataModel = {
  collectionRecs: params({
    collectionId: stringType().isRequired(),
    version: stringType(),
    appId: stringType(),
    maxCollections: stringType()
  }).shape({
    similarCollections: arrayType(shapeType({
      collectionId: stringType(),
      name: stringType(),
      url: stringType(),
      media: shapeType({
        images: arrayType(shapeType({
          url: stringType()
        }))
      })
    }))
  })
};

SimilarCollections.propTypes = {
  room: string,
  collectionId: string.isRequired
};

SimilarCollections.defaultProps = {
  room: ''
};
